module.exports = __webpack_public_path__ + "img/DE01784.4de777d5.svg";